// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (prefers-color-scheme: dark) {
  :root:not(.override-system-scheme-light) {
    color-scheme: dark;
  }
  :root:not(.override-system-scheme-light):not(data-theme), :root:not(.override-system-scheme-light)[data-theme=default] {
    --color-base-canvas: var(--gray-100);
    --color-base-input: var(--gray-100);
    --color-base-canvas-translucent: var(--gray-100-a);
    --color-base-border: var(--gray-150);
    --color-base-hint: var(--gray-300);
    --color-base-draw: var(--gray-400);
    --color-base-text: var(--gray-500);
    --color-base-warn: var(--orange-200);
    --color-elevated-canvas: var(--gray-150);
    --color-elevated-border: var(--gray-175);
    --color-elevated-hint: var(--gray-400);
    --color-elevated-input: var(--black);
    --color-elevated-invert: var(--black);
    --color-elevated-draw: var(--gray-800);
    --color-elevated-text: var(--gray-800);
    --color-emphasis-text: var(--white);
    --color-selected-canvas: var(--gray-175);
    --color-selected-border: var(--gray-400);
    --color-selected-draw: var(--blue-400);
    --color-selected-text: var(--blue-400);
    --color-elevated-warn: var(--orange-300);
    --color-elevated-success: var(--blue-500);
    --color-hinting-completed: var(--gray-600);
    --color-hinting-error: var(--color-elevated-warn);
    --color-hinting-error-old: var(--color-base-warn);
    --color-hinting-executing: var(--blue-500);
    --color-hinting-old: var(--gray-400);
    --opacity-logo-qci: 1.0;
    --color-hinting-azure-base: var(--color-base-text);
    --color-hinting-azure-elevated: var(--color-elevated-text);
  }
  :root:not(.override-system-scheme-light)[data-theme=colors-one] {
    --color-base-canvas: var(--gray-100);
    --color-base-input: var(--gray-100);
    --color-base-canvas-translucent: var(--gray-100-a);
    --color-base-border: var(--gray-150);
    --color-base-hint: var(--gray-300);
    --color-base-draw: var(--gray-400);
    --color-base-text: var(--gray-500);
    --color-base-warn: var(--orange-200);
    --color-elevated-canvas: var(--gray-150);
    --color-elevated-border: var(--gray-175);
    --color-elevated-hint: var(--gray-400);
    --color-elevated-input: var(--black);
    --color-elevated-invert: var(--black);
    --color-elevated-draw: var(--gray-800);
    --color-elevated-text: var(--gray-800);
    --color-emphasis-text: var(--white);
    --color-selected-canvas: var(--gray-175);
    --color-selected-border: var(--gray-400);
    --color-selected-draw: var(--blue-400);
    --color-selected-text: var(--blue-400);
    --color-elevated-warn: var(--orange-300);
    --color-elevated-success: var(--blue-500);
    --color-hinting-completed: var(--gray-600);
    --color-hinting-error: var(--color-elevated-warn);
    --color-hinting-error-old: var(--color-base-warn);
    --color-hinting-executing: var(--blue-500);
    --color-hinting-old: var(--gray-400);
    --opacity-logo-qci: 1.0;
    --color-hinting-azure-base: var(--color-base-text);
    --color-hinting-azure-elevated: var(--color-elevated-text);
    --color-hinting-azure-base: var(--microsoft-azure);
    --color-hinting-azure-elevated: var(--microsoft-azure);
  }
  :root:not(.override-system-scheme-light)[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value {
    color: var(--color-elevated-success);
    fill: var(--color-elevated-success);
  }
  :root:not(.override-system-scheme-light)[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value .icon.status-circle {
    fill: var(--color-elevated-success);
  }
}
@media (prefers-color-scheme: light) {
  :root:not(.override-system-scheme-dark) {
    color-scheme: light;
  }
  :root:not(.override-system-scheme-dark):not(data-theme), :root:not(.override-system-scheme-dark)[data-theme=default] {
    --color-base-canvas: var(--gray-900);
    --color-base-canvas-translucent: var(--gray-900-a);
    --color-base-border: var(--gray-700);
    --color-base-hint: var(--gray-600);
    --color-base-draw: var(--gray-400);
    --color-base-text: var(--gray-500);
    --color-base-input: var(--gray-900);
    --color-base-warn: var(--red-600);
    --color-elevated-canvas: var(--white);
    --color-elevated-border: var(--gray-850);
    --color-elevated-draw: var(--gray-100);
    --color-elevated-hint: var(--gray-600);
    --color-elevated-input: var(--white);
    --color-elevated-invert: var(--white);
    --color-elevated-text: var(--gray-100);
    --color-elevated-warn: var(--red-300);
    --color-elevated-success: var(--blue-300);
    --color-emphasis-text: var(--black);
    --color-selected-border: var(--gray-500);
    --color-selected-canvas: var(--gray-850);
    --color-selected-draw: var(--blue-300);
    --color-selected-text: var(--blue-300);
    --color-hinting-completed: var(--gray-300);
    --color-hinting-error: var(--color-elevated-warn);
    --color-hinting-error-old: var(--color-base-warn);
    --color-hinting-executing: var(--blue-300);
    --color-hinting-old: var(--gray-600);
    --color-hinting-azure-base: var(--color-base-text);
    --color-hinting-azure-elevated: var(--color-elevated-text);
    --opacity-logo-qci: 0.2;
  }
  :root:not(.override-system-scheme-dark)[data-theme=colors-one] {
    --color-base-canvas: var(--gray-900);
    --color-base-canvas-translucent: var(--gray-900-a);
    --color-base-border: var(--gray-700);
    --color-base-hint: var(--gray-600);
    --color-base-draw: var(--gray-400);
    --color-base-text: var(--gray-500);
    --color-base-input: var(--gray-900);
    --color-base-warn: var(--red-600);
    --color-elevated-canvas: var(--white);
    --color-elevated-border: var(--gray-850);
    --color-elevated-draw: var(--gray-100);
    --color-elevated-hint: var(--gray-600);
    --color-elevated-input: var(--white);
    --color-elevated-invert: var(--white);
    --color-elevated-text: var(--gray-100);
    --color-elevated-warn: var(--red-300);
    --color-elevated-success: var(--blue-300);
    --color-emphasis-text: var(--black);
    --color-selected-border: var(--gray-500);
    --color-selected-canvas: var(--gray-850);
    --color-selected-draw: var(--blue-300);
    --color-selected-text: var(--blue-300);
    --color-hinting-completed: var(--gray-300);
    --color-hinting-error: var(--color-elevated-warn);
    --color-hinting-error-old: var(--color-base-warn);
    --color-hinting-executing: var(--blue-300);
    --color-hinting-old: var(--gray-600);
    --color-hinting-azure-base: var(--color-base-text);
    --color-hinting-azure-elevated: var(--color-elevated-text);
    --opacity-logo-qci: 0.2;
    --color-hinting-azure-base: var(--microsoft-azure);
    --color-hinting-azure-elevated: var(--microsoft-azure);
  }
  :root:not(.override-system-scheme-dark)[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value {
    color: var(--color-elevated-success);
  }
  :root:not(.override-system-scheme-dark)[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value .icon.status-circle {
    fill: var(--color-elevated-success);
  }
}
:root, :root.override-system-scheme-dark {
  color-scheme: dark;
}
:root:not(data-theme), :root[data-theme=default], :root.override-system-scheme-dark:not(data-theme), :root.override-system-scheme-dark[data-theme=default] {
  --color-base-canvas: var(--gray-100);
  --color-base-input: var(--gray-100);
  --color-base-canvas-translucent: var(--gray-100-a);
  --color-base-border: var(--gray-150);
  --color-base-hint: var(--gray-300);
  --color-base-draw: var(--gray-400);
  --color-base-text: var(--gray-500);
  --color-base-warn: var(--orange-200);
  --color-elevated-canvas: var(--gray-150);
  --color-elevated-border: var(--gray-175);
  --color-elevated-hint: var(--gray-400);
  --color-elevated-input: var(--black);
  --color-elevated-invert: var(--black);
  --color-elevated-draw: var(--gray-800);
  --color-elevated-text: var(--gray-800);
  --color-emphasis-text: var(--white);
  --color-selected-canvas: var(--gray-175);
  --color-selected-border: var(--gray-400);
  --color-selected-draw: var(--blue-400);
  --color-selected-text: var(--blue-400);
  --color-elevated-warn: var(--orange-300);
  --color-elevated-success: var(--blue-500);
  --color-hinting-completed: var(--gray-600);
  --color-hinting-error: var(--color-elevated-warn);
  --color-hinting-error-old: var(--color-base-warn);
  --color-hinting-executing: var(--blue-500);
  --color-hinting-old: var(--gray-400);
  --opacity-logo-qci: 1.0;
  --color-hinting-azure-base: var(--color-base-text);
  --color-hinting-azure-elevated: var(--color-elevated-text);
}
:root[data-theme=colors-one], :root.override-system-scheme-dark[data-theme=colors-one] {
  --color-base-canvas: var(--gray-100);
  --color-base-input: var(--gray-100);
  --color-base-canvas-translucent: var(--gray-100-a);
  --color-base-border: var(--gray-150);
  --color-base-hint: var(--gray-300);
  --color-base-draw: var(--gray-400);
  --color-base-text: var(--gray-500);
  --color-base-warn: var(--orange-200);
  --color-elevated-canvas: var(--gray-150);
  --color-elevated-border: var(--gray-175);
  --color-elevated-hint: var(--gray-400);
  --color-elevated-input: var(--black);
  --color-elevated-invert: var(--black);
  --color-elevated-draw: var(--gray-800);
  --color-elevated-text: var(--gray-800);
  --color-emphasis-text: var(--white);
  --color-selected-canvas: var(--gray-175);
  --color-selected-border: var(--gray-400);
  --color-selected-draw: var(--blue-400);
  --color-selected-text: var(--blue-400);
  --color-elevated-warn: var(--orange-300);
  --color-elevated-success: var(--blue-500);
  --color-hinting-completed: var(--gray-600);
  --color-hinting-error: var(--color-elevated-warn);
  --color-hinting-error-old: var(--color-base-warn);
  --color-hinting-executing: var(--blue-500);
  --color-hinting-old: var(--gray-400);
  --opacity-logo-qci: 1.0;
  --color-hinting-azure-base: var(--color-base-text);
  --color-hinting-azure-elevated: var(--color-elevated-text);
  --color-hinting-azure-base: var(--microsoft-azure);
  --color-hinting-azure-elevated: var(--microsoft-azure);
}
:root[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value, :root.override-system-scheme-dark[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value {
  color: var(--color-elevated-success);
  fill: var(--color-elevated-success);
}
:root[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value .icon.status-circle, :root.override-system-scheme-dark[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value .icon.status-circle {
  fill: var(--color-elevated-success);
}

:root.override-system-scheme-light :root {
  color-scheme: light;
}
:root.override-system-scheme-light:not(data-theme), :root.override-system-scheme-light[data-theme=default] {
  --color-base-canvas: var(--gray-900);
  --color-base-canvas-translucent: var(--gray-900-a);
  --color-base-border: var(--gray-700);
  --color-base-hint: var(--gray-600);
  --color-base-draw: var(--gray-400);
  --color-base-text: var(--gray-500);
  --color-base-input: var(--gray-900);
  --color-base-warn: var(--red-600);
  --color-elevated-canvas: var(--white);
  --color-elevated-border: var(--gray-850);
  --color-elevated-draw: var(--gray-100);
  --color-elevated-hint: var(--gray-600);
  --color-elevated-input: var(--white);
  --color-elevated-invert: var(--white);
  --color-elevated-text: var(--gray-100);
  --color-elevated-warn: var(--red-300);
  --color-elevated-success: var(--blue-300);
  --color-emphasis-text: var(--black);
  --color-selected-border: var(--gray-500);
  --color-selected-canvas: var(--gray-850);
  --color-selected-draw: var(--blue-300);
  --color-selected-text: var(--blue-300);
  --color-hinting-completed: var(--gray-300);
  --color-hinting-error: var(--color-elevated-warn);
  --color-hinting-error-old: var(--color-base-warn);
  --color-hinting-executing: var(--blue-300);
  --color-hinting-old: var(--gray-600);
  --color-hinting-azure-base: var(--color-base-text);
  --color-hinting-azure-elevated: var(--color-elevated-text);
  --opacity-logo-qci: 0.2;
}
:root.override-system-scheme-light[data-theme=colors-one] {
  --color-base-canvas: var(--gray-900);
  --color-base-canvas-translucent: var(--gray-900-a);
  --color-base-border: var(--gray-700);
  --color-base-hint: var(--gray-600);
  --color-base-draw: var(--gray-400);
  --color-base-text: var(--gray-500);
  --color-base-input: var(--gray-900);
  --color-base-warn: var(--red-600);
  --color-elevated-canvas: var(--white);
  --color-elevated-border: var(--gray-850);
  --color-elevated-draw: var(--gray-100);
  --color-elevated-hint: var(--gray-600);
  --color-elevated-input: var(--white);
  --color-elevated-invert: var(--white);
  --color-elevated-text: var(--gray-100);
  --color-elevated-warn: var(--red-300);
  --color-elevated-success: var(--blue-300);
  --color-emphasis-text: var(--black);
  --color-selected-border: var(--gray-500);
  --color-selected-canvas: var(--gray-850);
  --color-selected-draw: var(--blue-300);
  --color-selected-text: var(--blue-300);
  --color-hinting-completed: var(--gray-300);
  --color-hinting-error: var(--color-elevated-warn);
  --color-hinting-error-old: var(--color-base-warn);
  --color-hinting-executing: var(--blue-300);
  --color-hinting-old: var(--gray-600);
  --color-hinting-azure-base: var(--color-base-text);
  --color-hinting-azure-elevated: var(--color-elevated-text);
  --opacity-logo-qci: 0.2;
  --color-hinting-azure-base: var(--microsoft-azure);
  --color-hinting-azure-elevated: var(--microsoft-azure);
}
:root.override-system-scheme-light[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value {
  color: var(--color-elevated-success);
}
:root.override-system-scheme-light[data-theme=colors-one] .pane.systems-pane .system-card.available .system-availability .data-value .icon.status-circle {
  fill: var(--color-elevated-success);
}`, "",{"version":3,"sources":["webpack://./src/style/color_scheme.scss"],"names":[],"mappings":"AA4GA;EACE;IACE,kBAAA;EA3GF;EA4GE;IA9GF,oCAAA;IACA,mCAAA;IACA,kDAAA;IACA,oCAAA;IACA,kCAAA;IACA,kCAAA;IACA,kCAAA;IACA,oCAAA;IAEA,wCAAA;IACA,wCAAA;IACA,sCAAA;IACA,oCAAA;IACA,qCAAA;IACA,sCAAA;IACA,sCAAA;IAEA,mCAAA;IAEA,wCAAA;IACA,wCAAA;IACA,sCAAA;IACA,sCAAA;IAEA,wCAAA;IACA,yCAAA;IAEA,0CAAA;IACA,iDAAA;IACA,iDAAA;IACA,0CAAA;IACA,oCAAA;IAEA,uBAAA;IAEA,kDAAA;IACA,0DAAA;EAFA;EA+EE;IAjHF,oCAAA;IACA,mCAAA;IACA,kDAAA;IACA,oCAAA;IACA,kCAAA;IACA,kCAAA;IACA,kCAAA;IACA,oCAAA;IAEA,wCAAA;IACA,wCAAA;IACA,sCAAA;IACA,oCAAA;IACA,qCAAA;IACA,sCAAA;IACA,sCAAA;IAEA,mCAAA;IAEA,wCAAA;IACA,wCAAA;IACA,sCAAA;IACA,sCAAA;IAEA,wCAAA;IACA,yCAAA;IAEA,0CAAA;IACA,iDAAA;IACA,iDAAA;IACA,0CAAA;IACA,oCAAA;IAEA,uBAAA;IAEA,kDAAA;IACA,0DAAA;IA4CA,kDAAA;IACA,sDAAA;EAbA;EAeA;IACE,oCAAA;IACA,mCAAA;EAbF;EAeE;IACE,mCAAA;EAbJ;AACF;AA2CA;EACE;IACE,mBAAA;EAzCF;EA0CE;IAlFF,oCAAA;IACA,kDAAA;IACA,oCAAA;IACA,kCAAA;IACA,kCAAA;IACA,kCAAA;IACA,mCAAA;IACA,iCAAA;IAEA,qCAAA;IACA,wCAAA;IACA,sCAAA;IACA,sCAAA;IACA,oCAAA;IACA,qCAAA;IACA,sCAAA;IACA,qCAAA;IACA,yCAAA;IAEA,mCAAA;IAEA,wCAAA;IACA,wCAAA;IACA,sCAAA;IACA,sCAAA;IAEA,0CAAA;IACA,iDAAA;IACA,iDAAA;IACA,0CAAA;IACA,oCAAA;IAEA,kDAAA;IACA,0DAAA;IACA,uBAAA;EAsCA;EAaE;IArFF,oCAAA;IACA,kDAAA;IACA,oCAAA;IACA,kCAAA;IACA,kCAAA;IACA,kCAAA;IACA,mCAAA;IACA,iCAAA;IAEA,qCAAA;IACA,wCAAA;IACA,sCAAA;IACA,sCAAA;IACA,oCAAA;IACA,qCAAA;IACA,sCAAA;IACA,qCAAA;IACA,yCAAA;IAEA,mCAAA;IAEA,wCAAA;IACA,wCAAA;IACA,sCAAA;IACA,sCAAA;IAEA,0CAAA;IACA,iDAAA;IACA,iDAAA;IACA,0CAAA;IACA,oCAAA;IAEA,kDAAA;IACA,0DAAA;IACA,uBAAA;IAsBA,kDAAA;IACA,sDAAA;EAiDA;EA/CA;IACE,oCAAA;EAiDF;EAhDE;IACE,mCAAA;EAkDJ;AACF;AAtBA;EACE,kBAAA;AAwBF;AAvBE;EArIA,oCAAA;EACA,mCAAA;EACA,kDAAA;EACA,oCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EAEA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,sCAAA;EACA,sCAAA;EAEA,mCAAA;EAEA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,sCAAA;EAEA,wCAAA;EACA,yCAAA;EAEA,0CAAA;EACA,iDAAA;EACA,iDAAA;EACA,0CAAA;EACA,oCAAA;EAEA,uBAAA;EAEA,kDAAA;EACA,0DAAA;AAwJF;AApDE;EAxIA,oCAAA;EACA,mCAAA;EACA,kDAAA;EACA,oCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EAEA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,sCAAA;EACA,sCAAA;EAEA,mCAAA;EAEA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,sCAAA;EAEA,wCAAA;EACA,yCAAA;EAEA,0CAAA;EACA,iDAAA;EACA,iDAAA;EACA,0CAAA;EACA,oCAAA;EAEA,uBAAA;EAEA,kDAAA;EACA,0DAAA;EA4CA,kDAAA;EACA,sDAAA;AA6IF;AA3IE;EACE,oCAAA;EACA,mCAAA;AA6IJ;AA3II;EACE,mCAAA;AA6IN;;AAvFE;EACE,mBAAA;AA0FJ;AAxFE;EAzGA,oCAAA;EACA,kDAAA;EACA,oCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,mCAAA;EACA,iCAAA;EAEA,qCAAA;EACA,wCAAA;EACA,sCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,sCAAA;EACA,qCAAA;EACA,yCAAA;EAEA,mCAAA;EAEA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,sCAAA;EAEA,0CAAA;EACA,iDAAA;EACA,iDAAA;EACA,0CAAA;EACA,oCAAA;EAEA,kDAAA;EACA,0DAAA;EACA,uBAAA;AA+LF;AArHE;EA5GA,oCAAA;EACA,kDAAA;EACA,oCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,mCAAA;EACA,iCAAA;EAEA,qCAAA;EACA,wCAAA;EACA,sCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,sCAAA;EACA,qCAAA;EACA,yCAAA;EAEA,mCAAA;EAEA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,sCAAA;EAEA,0CAAA;EACA,iDAAA;EACA,iDAAA;EACA,0CAAA;EACA,oCAAA;EAEA,kDAAA;EACA,0DAAA;EACA,uBAAA;EAsBA,kDAAA;EACA,sDAAA;AA0MF;AAxME;EACE,oCAAA;AA0MJ;AAzMI;EACE,mCAAA;AA2MN","sourcesContent":["@mixin color-scheme-default-dark {\n  --color-base-canvas: var(--gray-100);\n  --color-base-input: var(--gray-100);\n  --color-base-canvas-translucent: var(--gray-100-a);\n  --color-base-border: var(--gray-150);\n  --color-base-hint: var(--gray-300);\n  --color-base-draw: var(--gray-400);\n  --color-base-text: var(--gray-500);\n  --color-base-warn: var(--orange-200);\n\n  --color-elevated-canvas: var(--gray-150);\n  --color-elevated-border: var(--gray-175);\n  --color-elevated-hint: var(--gray-400);\n  --color-elevated-input: var(--black);\n  --color-elevated-invert: var(--black);\n  --color-elevated-draw: var(--gray-800);\n  --color-elevated-text: var(--gray-800);\n\n  --color-emphasis-text: var(--white);\n\n  --color-selected-canvas: var(--gray-175);\n  --color-selected-border: var(--gray-400);\n  --color-selected-draw: var(--blue-400);\n  --color-selected-text: var(--blue-400);\n\n  --color-elevated-warn: var(--orange-300);\n  --color-elevated-success: var(--blue-500);\n\n  --color-hinting-completed: var(--gray-600);\n  --color-hinting-error: var(--color-elevated-warn);\n  --color-hinting-error-old: var(--color-base-warn);\n  --color-hinting-executing: var(--blue-500);\n  --color-hinting-old: var(--gray-400);\n\n  --opacity-logo-qci: 1.0;\n\n  --color-hinting-azure-base: var(--color-base-text);\n  --color-hinting-azure-elevated: var(--color-elevated-text);\n}\n\n@mixin color-scheme-default-light {\n  --color-base-canvas: var(--gray-900);\n  --color-base-canvas-translucent: var(--gray-900-a);\n  --color-base-border: var(--gray-700);\n  --color-base-hint: var(--gray-600);\n  --color-base-draw: var(--gray-400);\n  --color-base-text: var(--gray-500);\n  --color-base-input: var(--gray-900);\n  --color-base-warn: var(--red-600);\n\n  --color-elevated-canvas: var(--white);\n  --color-elevated-border: var(--gray-850);\n  --color-elevated-draw: var(--gray-100);\n  --color-elevated-hint: var(--gray-600);\n  --color-elevated-input: var(--white);\n  --color-elevated-invert: var(--white);\n  --color-elevated-text: var(--gray-100);\n  --color-elevated-warn: var(--red-300);\n  --color-elevated-success: var(--blue-300);\n\n  --color-emphasis-text: var(--black);\n\n  --color-selected-border: var(--gray-500);\n  --color-selected-canvas: var(--gray-850);\n  --color-selected-draw: var(--blue-300);\n  --color-selected-text: var(--blue-300);\n\n  --color-hinting-completed: var(--gray-300);\n  --color-hinting-error: var(--color-elevated-warn);\n  --color-hinting-error-old: var(--color-base-warn);\n  --color-hinting-executing: var(--blue-300);\n  --color-hinting-old: var(--gray-600);\n\n  --color-hinting-azure-base: var(--color-base-text);\n  --color-hinting-azure-elevated: var(--color-elevated-text);\n  --opacity-logo-qci: 0.2;\n}\n\n@mixin color-scheme-colors-one-dark {\n  @include color-scheme-default-dark;\n\n  --color-hinting-azure-base: var(--microsoft-azure);\n  --color-hinting-azure-elevated: var(--microsoft-azure);\n\n  .pane.systems-pane .system-card.available .system-availability .data-value {\n    color: var(--color-elevated-success);\n    fill: var(--color-elevated-success);\n\n    .icon.status-circle {\n      fill: var(--color-elevated-success);\n    }\n  }\n}\n\n@mixin color-scheme-colors-one-light {\n  @include color-scheme-default-light;\n\n  --color-hinting-azure-base: var(--microsoft-azure);\n  --color-hinting-azure-elevated: var(--microsoft-azure);\n\n  .pane.systems-pane .system-card.available .system-availability .data-value {\n    color: var(--color-elevated-success);\n    .icon.status-circle {\n      fill: var(--color-elevated-success);\n    }\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  :root:not(.override-system-scheme-light) {\n    color-scheme: dark;\n    &:not(data-theme), &[data-theme=\"default\"] {\n      @include color-scheme-default-dark;\n    }\n    &[data-theme=\"colors-one\"] {\n      @include color-scheme-colors-one-dark;\n    }\n  }\n}\n\n@media (prefers-color-scheme: light) {\n  :root:not(.override-system-scheme-dark) {\n    color-scheme: light;\n    &:not(data-theme), &[data-theme=\"default\"] {\n      @include color-scheme-default-light;\n    }\n    &[data-theme=\"colors-one\"] {\n      @include color-scheme-colors-one-light;\n    }\n  }\n}\n\n:root, :root.override-system-scheme-dark {\n  color-scheme: dark;\n  &:not(data-theme), &[data-theme=\"default\"] {\n    @include color-scheme-default-dark;\n  }\n  &[data-theme=\"colors-one\"] {\n    @include color-scheme-colors-one-dark;\n  }\n}\n\n:root.override-system-scheme-light {\n  :root {\n    color-scheme: light;\n  }\n  &:not(data-theme), &[data-theme=\"default\"] {\n    @include color-scheme-default-light;\n  }\n  &[data-theme=\"colors-one\"] {\n    @include color-scheme-colors-one-light;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
